module.exports = __webpack_public_path__ + "static/ws-bc15e479f82720fe55dcf4fe33c75b12.jpg";